import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { CarouselRow, RoundRow } from '../../styles';
import { DRAFT_PICK_SLIDE_WIDTH, DraftPickContainer } from '../draftPickSlide/styles';
import { HeaderWrapper, MediumGapContainer } from '../header/styles';

export const SkeletonWrapper = styled.div`
    overflow: hidden;

    ${HeaderWrapper} {
        svg {
            .fill {
                fill: ${({ theme }) => theme.Surface.tertiary};
            }

            .border {
                fill: ${({ theme }) => theme.Surface.border};
            }

            height: 32px;
            width: 48px;
        }
    }

    ${MediumGapContainer} {
        position: relative;
        background-color: ${({ theme }) => theme.Surface.tertiary};
        border-radius: 30px;
        height: 16px;
        overflow: hidden;
    }

    ${RoundRow} {
        ${MediumGapContainer} {
            width: 85px;
        }
    }

    ${CarouselRow} {
        ${BaseStyle.Mixins.gaps.small}

        padding-left: 16px;
        overflow: hidden;

        ${DraftPickContainer} {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-right: 0;
            border-radius: 8px;
            overflow: hidden;
            min-width: ${DRAFT_PICK_SLIDE_WIDTH}px;
            background-color: ${({ theme }) => theme.Surface.tertiary};

            svg {
                .fill {
                    fill: ${({ theme }) => theme.Surface.secondary};
                }

                .border {
                    fill: ${({ theme }) => theme.Surface.border};
                }

                height: 30px;
                width: 45px;
            }
        }
    }
`;
